__turbopack_context__.v({
  "actions": "global-error-module-scss-module__vFjbda__actions",
  "body": "global-error-module-scss-module__vFjbda__body",
  "button": "global-error-module-scss-module__vFjbda__button",
  "code": "global-error-module-scss-module__vFjbda__code",
  "heading": "global-error-module-scss-module__vFjbda__heading",
  "inner": "global-error-module-scss-module__vFjbda__inner",
  "link": "global-error-module-scss-module__vFjbda__link",
  "message": "global-error-module-scss-module__vFjbda__message",
});
